import axios from "../axiosInstance";
import {  IBranchDistrictForm } from "../@types/branchDistrict.d";

export const getBranchDistrict = async () => {
    try {
        let response = await axios.get('/api/branch-hierarchy/get-district');
        const data = response.data
        return data
    } catch (error) {
        console.error(error)
    }
};

export const createBranchDistrict = async (initial: IBranchDistrictForm) => {
    try {
        let response = await axios.post('/api/branch-hierarchy/create-branch-district', initial);
        const data = response.data.branchDistrict
        return data
    } catch (error) {
        console.error(error)
    }
};

export const updateBranchDistrict = async (initial: IBranchDistrictForm) => {
    try {
        let response = await axios.put('/api/branch-hierarchy/update-branch-district', initial);
        const data = response.data.branchDistrict
        return data
    } catch (error) {
        console.error(error)
    }
};